import { useEventListener } from 'usehooks-ts'

import { useCartStore } from '@features/cart/model/useCartStore'

export default function useCartSyncStorage () {
  const rehydrate = useCartStore.persist?.rehydrate

  useEventListener('storage', (event: StorageEvent) => {
    if (event.key === 'cart-storage') {
      rehydrate?.()
    }
  })
}
